import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { toast } from 'react-toastify';
import { prepareCustomerDdtTemplateData } from '../../utils/prepareTemplateData';
import PrintDocxButton from '../../utils/PrintDocxButton';

export default function DGLTH_customer_ddt({ item, entity = null, refreshData }) {

    const navigate = useNavigate();

    const [modalStatusDelete, setModalStatusDelete] = useState(false);

    function openModalDelete() {
        setModalStatusDelete(true);
    }

    function closeModalDelete() {
        setModalStatusDelete(false);
    }

    async function unloadDDT() {
        let constraintsBlocked = [
            { fieldName: "id", type: "value", value: item.idCustomer }
        ]
        var sortingBlocked = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.searchItemsSimple('customer', 1, 100, sortingBlocked, '', [], constraintsBlocked);
        if (res.body[0].isBlocked === 1) {
            toast.error('Impossibile scaricare la merce perché il cliente ' + item.nameCustomer + " è bloccato.", { theme: 'colored' })
        } else {
            navigate('/page/UnloadDDTCustomer?id=' + item.id)
        }
    }

    function sendEmail() {
        navigate('/page/SendDocumentEmailCustomerDDT?id=' + item.id + '&e=customer_ddt')
    }

    async function deleteInvoice() {
        console.log(item.id)
        var data = {
            status: { value: '0_PENDING' }
        }
        var response = await DataManager.updateItem('customer_invoices', data, item.id);
        if (response.success === 1) {
            toast.success('Fattura annullata con successo!', { theme: 'colored' })
            closeModalDelete();
            refreshData();
        } else {
            toast.error("Errore nell'annullare la fattura!", { theme: 'colored' })
        }
    }

    async function loadPrintData() {
        const res = await DataManager.getItem('customer_ddt', item.id);
        if (res.success !== 1) return null;
        const data = res.body[0];

        let dataOrder = null;
        if (data.orderNumber) {
            let constraints = [
                { fieldName: "internalCode", type: "value", value: data.orderNumber }
            ];
            var sorting = { 'field': 'id', 'order': 'desc' };
            var resOrder = await DataManager.searchItems('customer_order', 1, 10, sorting, '', [], constraints);
            if (resOrder.success === 1 && resOrder.body && resOrder.body.length > 0) {
                dataOrder = resOrder.body[0];
            }
        }

        return {
            fileDocument: data.fileDocument,
            templateData: prepareCustomerDdtTemplateData(data, dataOrder),
            filename: 'ddt_' + data.internalCode,
            entity: 'customer_ddt',
            id: item.id
        };
    }

    return (
        <>
            {item.status.value !== '0_PENDING' ? <></>
                :
                <><Button onClick={() => { unloadDDT() }} size='sm' className='me-1' variant='success'>Scarica</Button></>}
            <PrintDocxButton
                templateKey="template_ddt_customer"
                loadData={loadPrintData}
            />
            {item?.unloadDDT === 1 ? <></> : <Button size='sm' variant='outline-primary' className='me-1' onClick={() => { sendEmail() }}>Invia email</Button>}
            {item.status.value !== "0_PENDING" ? <>
                <Button size='sm' variant='outline-danger' className='me-1' onClick={() => { openModalDelete() }}>Annulla</Button>
            </> : null}

            {modalStatusDelete ? <>
                <Modal show={modalStatusDelete} onHide={closeModalDelete}>
                    <Modal.Header closeButton>
                        <Modal.Title>Annulla fattura</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Sei sicuro di voler annullare la fattura?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModalDelete}>
                            No
                        </Button>
                        <Button variant="danger" onClick={deleteInvoice}>
                            Si, annulla
                        </Button>
                    </Modal.Footer>
                </Modal>
            </> : <></>}
        </>
    );
}
